import { env } from "./EnvironmentConfig";

export const APP_NAME = "SENDA";
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const API_CORE_BASE_URL = env.API_CORE_ENDPOINT_URL;
// export const APP_PREFIX_PATH = "/app";
// export const AUTH_PREFIX_PATH = "/auth";
export const PUBLIC_PREFIX_PATH = env.PUBLIC_PREFIX_PATH;
export const API_URL = env.API_URL;
